{
  "common": {
    "pcs": "шт."
  },
  "status": {
    "normal": "Норма",
    "warning": "Предупреждение",
    "danger": "Опасность",
    "offline": "Нет данных",
    "unknown": "Неизвестно"
  },
  "live": {
    "lastUpdate": "Последнее обновление: {{time}}",
    "reconnecting": "Связь потеряна — переподключение…"
  },
  "elements": {
    "titlePlaceholder": "Введите заголовок",
    "subtitlePlaceholder": "Введите название объекта",
    "imagePlaceholder": "Загрузите изображение",
    "gifPlaceholder": "Загрузите GIF",
    "videoPlaceholder": "Загрузите видео",
    "sectionsPlaceholder": "Здесь появятся разделы",
    "play": "Воспроизвести"
  },
  "languages": {
    "uz-Latn": "O’zb",
    "ru": "Рус",
    "en": "Eng"
  },
  "languageNames": {
    "uz-Latn": "O'zbekcha",
    "ru": "Русский",
    "en": "English"
  },
  "topbar": {
    "language": "Язык интерфейса",
    "notifications": "Уведомления",
    "noNotifications": "Новых уведомлений нет.",
    "themeToLight": "Светлая тема",
    "themeToDark": "Тёмная тема",
    "userMenu": "Меню пользователя",
    "online": "В сети",
    "edit": "Редактировать",
    "editDashboard": "Редактировать главную панель",
    "logout": "Выйти"
  },
  "viewer": {
    "loading": "Загрузка…",
    "loadError": "Не удалось загрузить данные",
    "retry": "Повторить",
    "emptyDashboard": "Главная панель ещё не настроена",
    "emptyDashboardHint": "Когда администратор добавит фон, виджеты и разделы, они появятся здесь.",
    "dashboard": "Главная панель",
    "backToDashboard": "Вернуться на главную панель",
    "sectionsNav": "Разделы",
    "collapseMenu": "Свернуть меню",
    "expandMenu": "Развернуть меню",
    "folders": "Папки",
    "statusLegend": "Состояние устройств",
    "fullscreen": "Во весь экран",
    "exitFullscreen": "Выйти из полноэкранного режима",
    "deviceInfo": "Информация об устройстве",
    "edit": "Редактировать",
    "sectionNotFound": "Раздел не найден",
    "emptySection": "В этом разделе пока нет данных",
    "emptySectionHint": "Когда будут добавлены чертёж, таблица или график, они появятся здесь."
  },
  "panels": {
    "drawing": "Расположение устройств на чертеже",
    "table": "Таблица",
    "chart": "График устройства"
  },
  "table": {
    "index": "№",
    "device": "Устройство",
    "measuredAt": "Время измерения",
    "value": "Значение",
    "status": "Состояние",
    "empty": "Нет устройств для отображения",
    "formulaError": "Ошибка"
  },
  "chart": {
    "noSeries": "Устройства для графика не выбраны",
    "waiting": "Ожидание данных…",
    "time": "Время"
  },
  "deviceInfo": {
    "title": "Информация об устройстве",
    "subtitle": "Информация об устройстве · {{tenant}}",
    "readings": "Показатели",
    "noReadings": "К устройству не привязаны показатели",
    "media": "Фото и видео",
    "mediaCount": "{{count}} шт.",
    "description": "Описание",
    "empty": "Дополнительная информация об устройстве не заполнена.",
    "close": "Закрыть",
    "pdf": "Скачать PDF",
    "previous": "Назад",
    "next": "Вперёд"
  }
}
